import { MaterialSymbolIcon } from './MaterialSymbolIcon';
import type { IconProps } from './types';

export function Icon({
  name,
  size = 'medium',
  fill = false,
  ...rest
}: IconProps) {
  return <MaterialSymbolIcon name={name} size={size} fill={fill} {...rest} />;
}
